import { CreateDiarioObrasResponse } from "../../../data/daos/create/create_diario_obra";
import { ICreateDiarioObraEfetivoUseCase } from "../../../presentation/useCases/create/create_diario_obra_efetivo_use_case";
import { ICreateDiarioObraEquipamentoUseCase } from "../../../presentation/useCases/create/create_diario_obra_equipamento_use_case";
import { ICreatDiarioObraUseCase } from "../../../presentation/useCases/create/create_diario_obra_use_case";
import { IDiarioObraRepository } from "../../repositories/diario_obra_repository";

// CreateDiarioObraEquipamentoUseCase


export class CreateDiarioObraEquipamentoUseCase implements ICreateDiarioObraEquipamentoUseCase {
  constructor(private readonly repository: IDiarioObraRepository) {}

  async createDiarioObraEquipamento( IdDiarioObras: number | null, IdMaquinaEquip: number | null, Descricao: string | null, Tipo: string | null,  Quantidade: number | null): Promise<void> {
    
    await this.repository.createDiarioObraEquipamento(
      IdDiarioObras, IdMaquinaEquip, Descricao, Tipo,  Quantidade
    );
  }
}
